import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const Ourclient = () => {
    const sectionStyle = {
        padding: '25px 0',
        background: 'linear-gradient(to right, #0A0909, #ff001E, #0A0909)',
    };

    const wrapperStyle = {
        padding: '20px 0'
    };

    const slideStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.3s ease',
        textAlign: 'center',
        gap: '60px', // Add gap between images in the slide
    };

    const imageStyle = {
        width: '200px', // Increased from 150px
        height: '200px', // Increased from 150px
        objectFit: 'contain',
        opacity: 1,
        transition: 'all 0.5s ease',
        cursor: 'pointer',
        margin: 0, // Remove margin, use gap instead
    };

    return (
        <>
            <div className="section-heading text-center mb-40">
                <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>Our <span className="hl">Clients</span></h2>
            </div>
            <div style={sectionStyle}>
                <div className="container">
                    <div style={wrapperStyle}>
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={60} // Increase space between slides
                            slidesPerView={4}
                            loop={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                },
                                576: {
                                    slidesPerView: 2,
                                },
                                768: {
                                    slidesPerView: 3,
                                },
                                992: {
                                    slidesPerView: 4,
                                },
                            }}
                        >
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/logo1.png" alt="img" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/logo2.jpg" alt="img" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/logo3.jpg" alt="img" />
                            </SwiperSlide>
                            <SwiperSlide style={slideStyle}>
                                <img style={imageStyle} src="assets/img/logo4.png" alt="img" />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Ourclient;
